<template>
  <RouterView />
</template>

<script setup lang="ts">
import { RouterView } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { watch } from 'vue'
import { Locale } from 'vant'
import zhCN from 'vant/es/locale/lang/zh-CN'
import enUS from 'vant/es/locale/lang/en-US'

const { t, locale } = useI18n()

// 更新页面标题
const updateTitle = () => {
  document.title = t('site.title')
}

// 语言切换时同步 Vant 内置文案（弹窗确认等）与页面标题
watch(
  locale,
  (lang) => {
    if (lang === 'zh') {
      Locale.use('zh-CN', zhCN)
    } else {
      Locale.use('en-US', enUS)
    }
    updateTitle()
  },
  { immediate: true },
)
</script>

<style>
:root {
  /* 主题色彩 */
  --van-primary-color: #1989fa;
  --van-success-color: #07c160;
  --van-danger-color: #ee0a24;

  /* 自定义颜色 */
  --app-gradient: linear-gradient(135deg, #1989fa33, #07c16033);
  --app-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
}

#app {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  box-sizing: border-box;
}

body {
  min-height: 100vh;
  background: var(--app-gradient);
  color: var(--van-text-color);
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,
    Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
}

/* 全局卡片样式 */
.van-card {
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(10px);
  border-radius: 12px;
  box-shadow: var(--app-shadow);
}

/* 导航栏样式 */
.van-nav-bar {
  background: transparent;
}

.van-nav-bar__text {
  color: var(--van-text-color);
}

/* 弹窗样式优化 */
.van-dialog {
  border-radius: 16px;
  overflow: hidden;
}

/* 响应式布局 */
@media (min-width: 768px) {
  .metronome {
    max-width: 600px;
    margin: 0 auto;
  }
}

@media (max-width: 767px) {
  #app {
    padding: 8px;
  }
}
</style>
